import React from 'react';

export function normalizeLevelYear(levelYear) {
  return levelYear === 'Year 1' || levelYear === 'Year 2' ? levelYear : null;
}

export default function YearLevelBadge({ levelYear, className = '' }) {
  const year = normalizeLevelYear(levelYear);
  const modifier = year === 'Year 2' ? 'year-2' : year === 'Year 1' ? 'year-1' : 'year-unassigned';

  return (
    <span className={`year-level-badge ${modifier} ${className}`.trim()}>
      {year ?? 'Unassigned'}
    </span>
  );
}